"use client";

import {useRef, useState} from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import emailjs from '@emailjs/browser'


export default function Formu(){

    const [contactInfo, setContactInfo] = useState({
        name: "",
        email: "",
        message: ""
    })

    console.log(contactInfo)

    const [checked, setChecked] = useState(false);

    const checkingBox= (e) => {
        setChecked(e.target.checked)
    }

    const [isEmpty, setIsEmpty] = useState(false);
     const [sent, setSent] = useState(false);


    const form = useRef();

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('clickando submit');

        if(contactInfo.name === "" || contactInfo.email === "" ||
        contactInfo.message === "" || checked === false){
            setIsEmpty(true);
        }else{
            emailjs.sendForm(
                "service_portfolio7",
                "template_49kt0nh",
                form.current,
                "XEkxAh28YjPuJBKNf"
            ).then((result) => {
                console.log(result.text + {contactInfo})
                // --- CLEAR FORM ---
                setContactInfo({
                    name: "",
                    email: "",
                    message: "",
                });
                setChecked(false);
                form.current.reset();

                setSent(true);
            },
            (error) => {
                console.log(error.text)
            })
        }
    }
    
    return(
            <form ref={form} onSubmit={onSubmit}>


                <div>

                
                    <TextField id="outlined-basic"
                    label="Name"
                    color="secondary"
                    type="text"
                    name="name"
                    margin="normal"
                    onChange={(e) => setContactInfo({ ...contactInfo, name: e.target.value})}
                    value={contactInfo.name}
                    sx={{
                        input: {
                            background: 'rgb(43, 43, 43)',
                            borderRadius: 2,
                            color: '#FFFFFF'
                        },
                        label:{
                            color: '#4dd0e1',
                            "&:hover":{color:'rgb(20, 213, 200)'},
                        },
                        root:{
                            "& .MuiInputBase-root.MuiFilledInput-root": {
                            color: "primary"
                        }}
                    }}
                    />

                    <TextField
                    id="outlined-basic"
                    label="E-mail"
                    color="secondary"
                    type="email"
                    name="email"
                    margin="normal"
                    pl={2}
                    onChange={(e) => setContactInfo({ ...contactInfo, email: e.target.value})}
                    value={contactInfo.email}
                    sx={{
                        input: {
                            background: 'rgb(43, 43, 43)',
                            borderRadius: 2,
                            color: '#FFFFFF'
                        },
                        label:{
                            color: '#4dd0e1',
                            "&:hover":{color:'rgb(20, 213, 200)'},
                        },
                        root:{
                            "& .MuiInputBase-root.MuiFilledInput-root": {
                            color: "primary"
                        },}
                    }}
                    />

                </div>


                <div>

                    <TextField fullWidth
                    id="outlined-basic"
                        label="Message"
                        color="secondary"
                        type="message"
                        name="message"
                        margin="normal"
                        onChange={(e) => setContactInfo({ ...contactInfo, message: e.target.value})}
                        value={contactInfo.message}
                        sx={{
                            input: {
                            background: 'rgb(43, 43, 43)',
                            borderRadius: 2,
                              color: '#FFFFFF'
                            },
                            label:{
                                color: '#4dd0e1',
                                "&:hover":{color:'rgb(20, 213, 200)'},
                            },
                            root:{
                                "& .MuiInputBase-root.MuiFilledInput-root": {
                                color: "primary"
                            },}
                        }}
                    />
                </div>

                <div>
                    <input type="checkbox" onChange={(e) => checkingBox(e)}></input>
                    <Typography color="white">Accept terms and conditions</Typography>
                </div>

                <div >

                    <Button variant="outlined" size="medium" 
                    type="submit"
                    color="secondary"
                    sx={{
                    left: '200px',
                    margin: '16px 122px',
                    fontFamily: 'Questrial',
                    borderColor: 'rgb(20, 213, 200)', ml:'30%', mt:2}}
                    >
                        Send
                    </Button>

                </div>

                {isEmpty && (
                        <Typography color="pink">You should fill in all the fields and accept the conditions
                        </Typography>
                    )}

                {sent && (
                        <Typography color="lightgreen" sx={{ mt: 2 }}>
                            Message sent successfully!
                        </Typography>
                    )}

            </form>
    )
}